const exportCsv = (pCsv: string, pNome: string) => {
  const hiddenElement = document.createElement('a');
  hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(pCsv);
  hiddenElement.target = '_blank';

  hiddenElement.download = `${pNome}.csv`;
  hiddenElement.click();
};

export { exportCsv };
